/* eslint-disable @typescript-eslint/no-explicit-any */
export class LinkElement extends HTMLElement {
  public static observedAttributes = ["text", "url"];
  public static onClickLink:
    | ((url: string, state?: unknown, replaceCurrentHref?: boolean) => void)
    | undefined = undefined;

  private aElement: HTMLAnchorElement = document.createElement("a");

  private _viewState: any | undefined = undefined;

  set text(value: string) {
    this.setAttribute("text", value);
  }

  get text() {
    return this.getAttribute("text") || "";
  }

  set url(value: string) {
    this.setAttribute("url", value);
  }

  get url() {
    return this.getAttribute("url") || "";
  }

  get viewState() {
    return this._viewState;
  }

  set viewState(value: any) {
    this._viewState = value;
  }

  constructor() {
    super();
    if (!LinkElement.onClickLink) {
      console.warn("LinkElement.onClickLink is not set");
    }
  }

  connectedCallback() {
    const a = this.aElement;
    const url = this.url;

    a.innerHTML = this.text;
    a.href = url;
    a.setAttribute("data-url", url);

    a.onclick = (ev: Event) => {
      ev.preventDefault();
      const url = a.getAttribute("data-url");
      if (url && LinkElement.onClickLink)
        LinkElement.onClickLink(url, this.viewState);
      return false;
    };

    this.appendChild(a);
  }

  attributeChangedCallback(attrName: string) {
    switch (attrName) {
      case "text": {
        this.aElement.innerHTML =
          this.attributes.getNamedItem("text")?.value || "";
        break;
      }
      case "url": {
        const url = this.attributes.getNamedItem("url")?.value || "";
        this.aElement.href = url;
        this.aElement.setAttribute("data-url", url);
        break;
      }
    }
  }
}

customElements.define("link-element", LinkElement);

declare global {
  interface HTMLElementTagNameMap {
    "link-element": LinkElement;
  }
}
